import { Button } from "@/common/button";
import { EButtonType } from "@/common/button/button-models";
import { PopupBackground } from "@/common/popups/common/popup-background";
import React from "react";

export const PopupWarningPaymentUser = React.memo(
  function PopupWarningPaymentUser(props: { onUnderstand: () => void }) {
    return (
      <PopupBackground title="Safety Alert">
        <div className="mt-5">
          <p className="mb-5 text-center text-body-lg font-normal text-body-text">
            Our cyber safety and fraud policies prevent discussing outside
            payments. If this message was in error, then please ignore.
          </p>

          <div className="mt-5">
            <Button
              buttonType={EButtonType.BlueWide}
              onClick={props.onUnderstand}
            >
              I understand
            </Button>
          </div>
        </div>
      </PopupBackground>
    );
  }
);
